import React from "react";

const Footer = () => {
  return (
    <footer id="footer">
      <div className="container">
        <div className="footer-top">
          <nav className="footer-links">
            <a href="#/downloads">Downloads</a>
            <a href="/terms.html" target="_blank" rel="noopener noreferrer">Terms of Use</a>
            <a href="/privacy-policy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          </nav>
        </div>

        <div className="footer-bottom">
          <div className="copyright">
            <strong>&copy; 2026 Vishal Sanjivini Villa Owners Maintenance Mutually Aided Cooperative Society</strong>
          </div>
          <div className="credits">
            All rights reserved. Vishal Sanjivini Villa Owners Maintenance Mutually Aided Cooperative Society
          </div>
          <p>
            This website is developed and maintained by the Vishal Sanjivini Villa Owners Maintenance Mutually Aided Cooperative Society.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
